import * as React from 'react';
import { ReactNode } from 'react';

interface Props {
  src: string;
  alt: string;
}

export const InlineIcon = (props: Props): ReactNode => {
  return <img className={'mx-1'} style={{height: '1em', maxHeight: '1em', width: 'auto', maxWidth: '1.5em', borderRadius: 0}}
              src={props.src} alt={props.alt}/>;
};
